import { useContext } from 'react';
import { AppContext, IAppContext } from '@palomina/palomina-website/context';

export const useApp = (): IAppContext => useContext(AppContext);

export default useApp;
